// i18n keys of the multi-tenant work package "teamcal" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  teamcal_title: 'Team calendars',
  teamcal_hint: 'Staff CalDAV mailboxes shown on the Calendar, in this order. Passwords are stored encrypted and are never shown again.',
  teamcal_add: 'Add calendar',
  teamcal_email: 'Mailbox',
  teamcal_label: 'Label',
  teamcal_color: 'Colour',
  teamcal_password: 'Password',
  teamcal_password_keep: 'Leave blank to keep the current password',
  teamcal_pw_none: 'Not set',
  teamcal_pw_sealed: 'Set (encrypted)',
  teamcal_pw_plain: 'Set (plain text)',
  teamcal_pw_unreadable: 'Unreadable — enter it again',
  teamcal_shown_as: 'Shown as {{name}}',
  teamcal_shown_as_hint: 'The login\'s nickname (Admin → Users) replaces the label on the Calendar.',
  teamcal_test: 'Test login',
  teamcal_testing: 'Testing…',
  teamcal_test_ok: 'Login accepted — {{n}} calendar(s)',
  teamcal_test_fail: 'Login failed: {{error}}',
  teamcal_deactivate: 'Deactivate',
  teamcal_reactivate: 'Reactivate',
  teamcal_confirm_deactivate: 'Hide the calendar "{{label}}" from the Calendar? It can be reactivated later.',
  teamcal_inactive: 'Deactivated ({{n}})',
  teamcal_none: 'No team calendars yet.',
  teamcal_seal: 'Encrypt {{n}} plain-text password(s)',
  teamcal_sealed_msg: 'Encrypted {{n}} password(s).',
  teamcal_move_up: 'Move up',
  teamcal_move_down: 'Move down',
  teamcal_err_email: 'Enter a valid mailbox address.',
  teamcal_err_label: 'A label is required.',
  teamcal_err_color: 'Colour must be #RRGGBB.',
  teamcal_err_password: 'The mailbox password is required.',
  teamcal_err_dup: 'This mailbox already has a team calendar (it may be deactivated — reactivate it instead).',
};
export const zh: Record<string, string> = {
  teamcal_title: '团队日历',
  teamcal_hint: '日历页显示的员工 CalDAV 邮箱,按此顺序排列。密码加密保存,保存后不再显示。',
  teamcal_add: '添加日历',
  teamcal_email: '邮箱',
  teamcal_label: '标签',
  teamcal_color: '颜色',
  teamcal_password: '密码',
  teamcal_password_keep: '留空则保留当前密码',
  teamcal_pw_none: '未设置',
  teamcal_pw_sealed: '已设置(加密)',
  teamcal_pw_plain: '已设置(明文)',
  teamcal_pw_unreadable: '无法解密——请重新输入',
  teamcal_shown_as: '显示为 {{name}}',
  teamcal_shown_as_hint: '该登录的昵称(后台 → 用户)会替代日历上的标签。',
  teamcal_test: '测试登录',
  teamcal_testing: '测试中…',
  teamcal_test_ok: '登录成功——{{n}} 个日历',
  teamcal_test_fail: '登录失败:{{error}}',
  teamcal_deactivate: '停用',
  teamcal_reactivate: '重新启用',
  teamcal_confirm_deactivate: '要在日历页隐藏「{{label}}」吗?之后可以重新启用。',
  teamcal_inactive: '已停用({{n}})',
  teamcal_none: '还没有团队日历。',
  teamcal_seal: '加密 {{n}} 个明文密码',
  teamcal_sealed_msg: '已加密 {{n}} 个密码。',
  teamcal_move_up: '上移',
  teamcal_move_down: '下移',
  teamcal_err_email: '请输入有效的邮箱地址。',
  teamcal_err_label: '标签不能为空。',
  teamcal_err_color: '颜色格式须为 #RRGGBB。',
  teamcal_err_password: '必须填写邮箱密码。',
  teamcal_err_dup: '这个邮箱已有团队日历(可能已停用——请重新启用它)。',
};
export const th: Record<string, string> = {
  teamcal_title: 'ปฏิทินทีม',
  teamcal_hint: 'กล่องอีเมล CalDAV ของพนักงานที่แสดงในหน้าปฏิทิน ตามลำดับนี้ รหัสผ่านถูกเก็บแบบเข้ารหัสและจะไม่แสดงอีก',
  teamcal_add: 'เพิ่มปฏิทิน',
  teamcal_email: 'กล่องอีเมล',
  teamcal_label: 'ชื่อที่แสดง',
  teamcal_color: 'สี',
  teamcal_password: 'รหัสผ่าน',
  teamcal_password_keep: 'เว้นว่างไว้เพื่อใช้รหัสผ่านเดิม',
  teamcal_pw_none: 'ยังไม่ได้ตั้ง',
  teamcal_pw_sealed: 'ตั้งแล้ว (เข้ารหัส)',
  teamcal_pw_plain: 'ตั้งแล้ว (ไม่เข้ารหัส)',
  teamcal_pw_unreadable: 'อ่านไม่ได้ — กรุณากรอกใหม่',
  teamcal_shown_as: 'แสดงเป็น {{name}}',
  teamcal_shown_as_hint: 'ชื่อเล่นของผู้ใช้ (ผู้ดูแล → ผู้ใช้) จะแสดงแทนชื่อนี้ในปฏิทิน',
  teamcal_test: 'ทดสอบการเข้าสู่ระบบ',
  teamcal_testing: 'กำลังทดสอบ…',
  teamcal_test_ok: 'เข้าสู่ระบบได้ — {{n}} ปฏิทิน',
  teamcal_test_fail: 'เข้าสู่ระบบไม่สำเร็จ: {{error}}',
  teamcal_deactivate: 'ปิดใช้งาน',
  teamcal_reactivate: 'เปิดใช้งานอีกครั้ง',
  teamcal_confirm_deactivate: 'ซ่อนปฏิทิน "{{label}}" จากหน้าปฏิทินหรือไม่? สามารถเปิดใช้งานอีกครั้งได้ภายหลัง',
  teamcal_inactive: 'ปิดใช้งานแล้ว ({{n}})',
  teamcal_none: 'ยังไม่มีปฏิทินทีม',
  teamcal_seal: 'เข้ารหัสรหัสผ่านที่ไม่ได้เข้ารหัส {{n}} รายการ',
  teamcal_sealed_msg: 'เข้ารหัสแล้ว {{n}} รายการ',
  teamcal_move_up: 'เลื่อนขึ้น',
  teamcal_move_down: 'เลื่อนลง',
  teamcal_err_email: 'กรุณากรอกอีเมลให้ถูกต้อง',
  teamcal_err_label: 'ต้องระบุชื่อที่แสดง',
  teamcal_err_color: 'สีต้องอยู่ในรูปแบบ #RRGGBB',
  teamcal_err_password: 'ต้องระบุรหัสผ่านของกล่องอีเมล',
  teamcal_err_dup: 'กล่องอีเมลนี้มีปฏิทินทีมอยู่แล้ว (อาจถูกปิดใช้งาน — ให้เปิดใช้งานอีกครั้งแทน)',
};
